module.exports = __webpack_public_path__ + "static/img/1.d63c679.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1.jpeg
// module id = X/xc
// module chunks = 1